module.exports = __webpack_public_path__ + "static/media/report.a86d90cc.png";